import src from "IMAGE";
export default { src, width: 640, height: 579, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
